export default "__VITE_ASSET__DtOkWJsr__"